import React from "react";

import { useActionText } from "../../ConditionBuilder/hooks/useActionText";
import { useConditionText } from "../../ConditionBuilder/hooks/useConditionText";
import styles from "./styles.css";

const RuleRowText = ({ column, rule, name }) => {
	const actionLabel = useActionText(rule, name);
	const conditionLabel = useConditionText(rule);

	if (column === "condition") {
		return (
			<div className={styles.ruleCell}>
				<p>{conditionLabel}</p>
			</div>
		);
	}

	return (
		<div className={styles.ruleCell}>
			<p>{actionLabel}</p>
		</div>
	);
};

export default RuleRowText;
